// /utils/macRegions.js

const macRegions = [
    { macName: "Noridian", lcdStatus: "retired", state: "Alaska", abbreviation: "AK", jurisdiction: "JF" },
    { macName: "Noridian", lcdStatus: "retired", state: "Arizona", abbreviation: "AZ", jurisdiction: "JF" },
    { macName: "Noridian", lcdStatus: "retired", state: "California", abbreviation: "CA", jurisdiction: "JE" },
    { macName: "Noridian", lcdStatus: "retired", state: "Hawaii", abbreviation: "HI", jurisdiction: "JE" },
    { macName: "Noridian", lcdStatus: "retired", state: "Idaho", abbreviation: "ID", jurisdiction: "JF" },
    { macName: "Noridian", lcdStatus: "retired", state: "Montana", abbreviation: "MT", jurisdiction: "JF" },
    { macName: "Noridian", lcdStatus: "retired", state: "Nevada", abbreviation: "NV", jurisdiction: "JE" },
    { macName: "Noridian", lcdStatus: "retired", state: "North Dakota", abbreviation: "ND", jurisdiction: "JF" },
    { macName: "Noridian", lcdStatus: "retired", state: "Oregon", abbreviation: "OR", jurisdiction: "JF" },
    { macName: "Noridian", lcdStatus: "retired", state: "South Dakota", abbreviation: "SD", jurisdiction: "JF" },
    { macName: "Noridian", lcdStatus: "retired", state: "Utah", abbreviation: "UT", jurisdiction: "JF" },
    { macName: "Noridian", lcdStatus: "retired", state: "Washington", abbreviation: "WA", jurisdiction: "JF" },
    { macName: "Noridian", lcdStatus: "retired", state: "Wyoming", abbreviation: "WY", jurisdiction: "JF" },
    { macName: "Noridian", lcdStatus: "retired", state: "Guam", abbreviation: "GU", jurisdiction: "JE" },
    { macName: "Noridian", lcdStatus: "retired", state: "Northern Mariana Islands", abbreviation: "MP", jurisdiction: "JE" },
    { macName: "Noridian", lcdStatus: "retired", state: "American Samoa", abbreviation: "AS", jurisdiction: "JE" },
  
    { macName: "NGS", lcdStatus: "retired", state: "Connecticut", abbreviation: "CT", jurisdiction: "JK" },
    { macName: "NGS", lcdStatus: "retired", state: "Illinois", abbreviation: "IL", jurisdiction: "J6"},
    { macName: "NGS", lcdStatus: "retired", state: "Maine", abbreviation: "ME", jurisdiction: "JK"  },
    { macName: "NGS", lcdStatus: "retired", state: "Massachusetts", abbreviation: "MA", jurisdiction: "JK"  },
    { macName: "NGS", lcdStatus: "retired", state: "Minnesota", abbreviation: "MN", jurisdiction: "J6" },
    { macName: "NGS", lcdStatus: "retired", state: "New Hampshire", abbreviation: "NH", jurisdiction: "JK"  },
    { macName: "NGS", lcdStatus: "retired", state: "New York", abbreviation: "NY", jurisdiction: "JK"  },
    { macName: "NGS", lcdStatus: "retired", state: "Rhode Island", abbreviation: "RI", jurisdiction: "JK"  },
    { macName: "NGS", lcdStatus: "retired", state: "Vermont", abbreviation: "VT", jurisdiction: "JK"  },
    { macName: "NGS", lcdStatus: "retired", state: "Wisconsin", abbreviation: "WI", jurisdiction: "J6" },
  
    { macName: "Palmetto", lcdStatus: "retired", state: "Alabama", abbreviation: "AL", jurisdiction: "JJ"  },
    { macName: "Palmetto", lcdStatus: "retired", state: "Georgia", abbreviation: "GA", jurisdiction: "JJ"  },
    { macName: "Palmetto", lcdStatus: "retired", state: "North Carolina", abbreviation: "NC", jurisdiction: "JM"  },
    { macName: "Palmetto", lcdStatus: "retired", state: "South Carolina", abbreviation: "SC", jurisdiction: "JM" },
    { macName: "Palmetto", lcdStatus: "retired", state: "Tennessee", abbreviation: "TN", jurisdiction: "JJ"  },
    { macName: "Palmetto", lcdStatus: "retired", state: "Virginia", abbreviation: "VA", jurisdiction: "JM" },
    { macName: "Palmetto", lcdStatus: "retired", state: "West Virginia", abbreviation: "WV", jurisdiction: "JM" },
  
    { macName: "WPS", lcdStatus: "retired", state: "Indiana", abbreviation: "IN", jurisdiction: "J8" },
    { macName: "WPS", lcdStatus: "retired", state: "Iowa", abbreviation: "IA", jurisdiction: "J5" },
    { macName: "WPS", lcdStatus: "retired", state: "Kansas", abbreviation: "KS", jurisdiction: "J5" },
    { macName: "WPS", lcdStatus: "retired", state: "Michigan", abbreviation: "MI", jurisdiction: "J8" },
    { macName: "WPS", lcdStatus: "retired", state: "Missouri", abbreviation: "MO", jurisdiction: "J5" },
    { macName: "WPS", lcdStatus: "retired", state: "Nebraska", abbreviation: "NE", jurisdiction: "J5" },
  
    { macName: "CGS", lcdStatus: "active", state: "Kentucky", abbreviation: "KY", jurisdiction: "J15" },
    { macName: "CGS", lcdStatus: "active", state: "Ohio", abbreviation: "OH", jurisdiction: "J15" },
  
    { macName: "FCSO", lcdStatus: "active", state: "Florida", abbreviation: "FL", jurisdiction: "JN" },
    { macName: "FCSO", lcdStatus: "active", state: "Puerto Rico", abbreviation: "PR", jurisdiction: "JN" },
    { macName: "FCSO", lcdStatus: "active", state: "U.S. Virgin Islands", abbreviation: "VI", jurisdiction: "JN" },
  
    { macName: "Novitas", lcdStatus: "active", state: "Arkansas", abbreviation: "AR", jurisdiction: "JH" },
    { macName: "Novitas", lcdStatus: "active", state: "Colorado", abbreviation: "CO", jurisdiction: "JH" },
    { macName: "Novitas", lcdStatus: "active", state: "Louisiana", abbreviation: "LA", jurisdiction: "JH" },
    { macName: "Novitas", lcdStatus: "active", state: "Mississippi", abbreviation: "MS", jurisdiction: "JH" },
    { macName: "Novitas", lcdStatus: "active", state: "New Mexico", abbreviation: "NM", jurisdiction: "JH" },
    { macName: "Novitas", lcdStatus: "active", state: "Oklahoma", abbreviation: "OK", jurisdiction: "JH" },
    { macName: "Novitas", lcdStatus: "active", state: "Texas", abbreviation: "TX", jurisdiction: "JH" },
    { macName: "Novitas", lcdStatus: "active", state: "Pennsylvania", abbreviation: "PA", jurisdiction: "JL" },
    { macName: "Novitas", lcdStatus: "active", state: "New Jersey", abbreviation: "NJ", jurisdiction: "JL" },
    { macName: "Novitas", lcdStatus: "active", state: "Delaware", abbreviation: "DE", jurisdiction: "JL" },
    { macName: "Novitas", lcdStatus: "active", state: "Maryland", abbreviation: "MD", jurisdiction: "JL" },
    { macName: "Novitas", lcdStatus: "active", state: "District of Columbia", abbreviation: "DC", jurisdiction: "JL" },
  ];

  export default macRegions;
  
// Main lookup function
export function getMacRegion(input) {
    if (!input) return null;
    const cleaned = input.trim().toLowerCase();
  
    return macRegions.find(
      entry =>
        entry.abbreviation.toLowerCase() === cleaned ||
        entry.state.toLowerCase() === cleaned
    ) || null;
  }
  
  // Helper: check if LCD is retired for given state or abbreviation
  export function isLcdRetired(input) {
    const region = getMacRegion(input);
    return region ? region.lcdStatus === "retired" : false;
  }
  
  // Helper: return a message about LCD status for UI use
  export function getMacWarning(input) {
    const region = getMacRegion(input);
    if (!region) return null;
  
    const base = `${region.state} is in the ${region.macName} MAC region.`;
  
    if (region.lcdStatus === "retired") {
      return (
        `${base} This MAC has **retired LCDs**, and CuraGenesis does **not recommend proceeding** unless you have verified coverage through alternate means. ` +
        `Reimbursement is unlikely and must be confirmed directly with the payer. ` +
        `If you choose to proceed, it is at your own risk. We strongly advise informing the patient that coverage is **not guaranteed** and may be denied.`
      );
    } else {
      return `${base} This MAC has active LCDs. Standard LCD rules may apply based on wound type and documentation.`;
    }
  }
  
  